export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '守护甜心到底讲了一个什么样的故事？',
    a: '《守护甜心》围绕"心灵之蛋"展开：每个孩子心里都有一颗藏着真实愿望的蛋，如果愿望足够强烈，蛋就会孵化成"守护甜心"，成为孩子忠实的伙伴。主角日奈森亚梦同时拥有多颗守护蛋，加入圣夜学园守护者后，与伙伴们一起守护孩子们的心灵之蛋，阻止复活社的阴谋。故事既讲述奇幻的"角色变换"冒险，也细腻地刻画了角色们面对自我、学会成长的青春故事。',
  },
  {
    q: '什么是"角色变换"和"角色改造"？',
    a: '"角色变换"是守护甜心的核心能力：当守护甜心与主人心意相通、能量满格时，守护甜心会与主人合体，赋予主人全新的性格与能力，比如亚梦的小兰能让她变得运动力十足、口直心快。"角色改造"则是一种较为温和的形态，守护甜心会直接操控主人的某个部位或性格特征，例如让亚梦突然说出真心话或做出意外的举动，是剧情中非常有趣的萌点。',
  },
  {
    q: '日奈森亚梦一共有几颗守护蛋、几个守护甜心？',
    a: '日奈森亚梦是圣夜学园守护者中独一无二的"Joker"，也是全作拥有最多守护甜心的角色。她先后拥有小兰（运动系）、米奇（艺术系）、苏（料理系）三颗守护甜心，此外还有第四颗身份神秘、经历觉醒的守护蛋——方块。四颗守护甜心分别对应亚梦不同层面的性格，共同构成了"虽然不完美、却很真实"的她。',
  },
  {
    q: '月咏几斗和星名歌呗是什么关系？',
    a: '星名歌呗是月咏几斗同母异父的妹妹。两人的童年因为家庭变故与复活社的介入而蒙上阴影，几斗为了家人背负了太多。歌呗表面上是一心追逐舞台的人气偶像，实际上她所做的一切——包括与复活社周旋——都是为了能拯救哥哥几斗。这段"嘴上不说、心里在乎"的兄妹情，是全作最戳心的情感线之一。',
  },
  {
    q: '守护甜心的"心灵之蛋"为什么要被守护？',
    a: '在《守护甜心》的世界观里，"心灵之蛋"象征孩子内心真实而珍贵的愿望与梦想。如果愿望被压抑、扭曲，心灵之蛋就会变成"坏蛋"，孩子也会随之迷失自我。守护者们以圣夜学园守护者的身份，负责发现并净化这些坏蛋，帮助孩子们找回真实的自己。因此"守护甜心"不止是伙伴，更代表着对纯真与梦想的守护。',
  },
  {
    q: '圣夜学园的守护者都有哪些职位？',
    a: '圣夜学园的守护者组织设有五位固定职位：King（王）、Queen（后）、Jack（侍卫）、Ace（王牌）以及最特别的Joker（百搭牌）。担任King的是边里唯世，担任Queen的先后有藤咲凪彦（抚子）与真城璃舞，担任Jack的是相马空海，担任Ace的是结木弥耶，而独一无二的Joker则是主角日奈森亚梦。',
  },
  {
    q: '《守护甜心》一共有几季动画？',
    a: '《守护甜心》TV动画共分三季：第一季《守护甜心！》、第二季《守护甜心！！心跳》、第三季《守护甜心！！派对！》。三季动画围绕亚梦与守护者们对抗复活社、守护心灵之蛋的冒险展开，也一步步推进了角色们各自的情感与成长。想一次性补完角色故事，可以从第一季一路看到第三季。',
  },
];